// extracted by mini-css-extract-plugin
module.exports = {"noResourcesMsg":"messages_noResourcesMsg__3pgYK","chosenLanguage":"messages_chosenLanguage__1cXYI"};